exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-button-container[data-v-4f048a58]{text-align:center}.bottom-button-container .main-header[data-v-4f048a58]{text-align:center;margin-top:20px;margin-bottom:25px}.bottom-button-container button[data-v-4f048a58]:not(:last-child){margin-bottom:15px}.outlets-list[data-v-4f048a58]{height:100%;overflow-y:scroll;background:#fff;position:absolute;width:100%}.big-button-container[data-v-4f048a58]{position:fixed;right:0;bottom:2vh}.content[data-v-4f048a58]{height:100%;overflow-x:scroll}@media (max-height:667px){.bottom-button-container .main-header[data-v-4f048a58]{font-size:22px;margin-top:10px;margin-bottom:15px}.front-image[data-v-4f048a58]{height:45vh;object-fit:cover}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f048a58","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/outlets/outlets.vue
// module id = cmjL
// module chunks = 0